import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/case-studies/mobius/mob-banner.png";

function Banner() {
  return (
    <section
      className="banner_mobius text_white"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo mb-4">
              <StaticImage
                src="../../../images/case-studies/mobius/logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={460}
                height={73}
              />
            </div>
            <h1>Introduction</h1>
            <p>
              Mobius Risk Group is an independent multi-asset risk advisory
              firm, offering appropriate market guidance to manufacturers,
              patrons, and capital market participants.
            </p>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={7}
            xxl={7}
            className="my-auto text-center"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/mobius/banner-man.png"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={855}
                height={870}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
